import {useTranslation} from "next-i18next";
import Image from "next/image";
import ContactForm, {ContactFormInterface} from "../ContactForm/ContactForm";
import AgbChecklist from "./AgbChecklist";
import SpamFilterQuestion from "./SpamFilterQuestion";
import Button from "./Button";
import {useState} from "react";
import {useRouter} from "next/router";
import {requestsCreationAttributes} from "../../models/requests";
import ContactTypeEnums from "../../enums/ContactTypeEnums";
import {postRequest} from "../../data/ReactQueries";

export default function ContactFormSection(){
    const {t} = useTranslation();

	const router = useRouter();
	const [agbAccepted, setAgbAccepted] = useState(false);

	const [contactForm, setContactForm] = useState<ContactFormInterface>({
		customer_id: 0,
		email: "",
		firstname: "",
		lastname: "",
		title: "Herr"
	});

	const [requestCreateObject, setRequestCreateObject] =
		useState<requestsCreationAttributes | null>({
			object_id: "",
			from_date: "",
			to_date: "",
			persons: "",
			children: "",
			additional_information: "",
			email: "",
			babybuggys: 0,
			babychairs: 0,
			pets: "",
			bedding: 0,
			city: "",
			contact_type:
			ContactTypeEnums.kontakt /* (router.query.source as string) ?? "kontakt" */,
			created: 0,
			firstname: "",
			lastname: "",
			phone: "",
			customer_id: "",
			street: "",
			extrabeds: 0,
			fax: "",
			languagecode: router.locale ?? "",
			message: "",
			mobile: "",
			number: "",
			pets_amount: 0,
			postcode: "",
			read: 0,
			responded: 0,
			responded_from: "",
			title: "Herr",
			towels: 0
		});

	function handleSubmitContactForm(
		e: React.FormEvent<HTMLFormElement>,
		locale = "en"
	) {
		e.preventDefault();
		if (!requestCreateObject) return;
		postRequest(requestCreateObject, locale);
		router.push("/contact-success");
	}

	function updateRequestCreateObject(
		key: keyof requestsCreationAttributes,
		value: requestsCreationAttributes[keyof requestsCreationAttributes]
	) {
		setRequestCreateObject((prev) => {
			if (prev === null) {
				return {
					[key]: value
				} as requestsCreationAttributes;
			}
			return {
				...prev,
				[key]: value
			};
		});
	}


	const [spamFilterPassed, setSpamFilterPassed] = useState(false);

    return (
        <div className="w-full flex flex-col items-center relative" id="contact">
            <Image
                src="/images/home-kaufen-und-verkaufen.png"
                title="Buy and sell"
                alt="Buy and sell"
                fill
                className="w-full object-cover -z-[1]"
            />
            <div className="w-full h-full z-1 top-0 left-0 flex flex-col justify-around items-center text-white pt-8 pb-10 lg:pb-20 lg:pt-12">
                <h2 className="font-light mb-8">{t("common.contactUs")}</h2>
                <div className="flex flex-col items-center mb-4">
                    <p className="font-semibold">{t("consts.address.line1")}</p>
                    <p className="font-semibold">{t("consts.address.line2")}</p>
                    <p className="font-semibold">{t("consts.address.line3")}</p>
                    <p className="font-semibold">{t("consts.address.line4")}</p>
                </div>
                <div className="flex flex-col items-center">
                    <p className="font-semibold">{t("consts.contact.tel")}</p>
                    <p className="font-semibold">{t("consts.contact.email")}</p>
                </div>

				<div className="text-black max-w-[1240px] px-[20px] ">
					<form
						id="contact-form"
						onSubmit={(e) => handleSubmitContactForm(e, router.locale)}
						className="flex flex-col gap-4 p-8 lg:px-32 lg:py-16 bg-white rounded-[20px] mt-8 shadow-[0px_1px_6px_rgba(0,0,0,0.1607843137)]"
					>
						<ContactForm
							smallVersion
							onChange={(key, value) => {
								updateRequestCreateObject(key, value);
							}}
							showMessage={false}
						/>
						<div className="grid grid-cols-1 lg:grid-cols-5 gap-x-6 gap-y-6 place-content-stretch place-items-stretch justify-end">
							<div className="lg:col-start-2 col-span-4">
								<AgbChecklist onChange={setAgbAccepted}/>
								<div className="mt-6" />
								<SpamFilterQuestion onChange={setSpamFilterPassed}/>
								<div className="mt-12" />
								<div className="flex flex-row items-end justify-end gap-8 flex-wrap">
									<Button
										text={t("pages.contact.form.reset")}
										transparent={false}
										border={false}
										type="reset"
										minWidth={"sm:w-min w-full"}
										onClick={(e) => {
											setAgbAccepted(false);
											setContactForm({
												customer_id: 0,
												email: "",
												firstname: "",
												lastname: "",
												title: "Herr"
											});
										}}
										height={"h-[48px]"}
										className="rounded-[10px]"
										padding={"px-6 py-[14px] uppercase font-bold text-[14px]"}
										bgColor="bg-gradient-to-b from-[#b6aa9b] to-[#857a6d]"
										hoverBgColor="hover:bg-leo-dark-brown hover:from-transparent hover:to-transparent"
									/>
									<Button
										text={t("pages.contact.form.submit")}
										transparent={false}
										border={false}
										minWidth={"sm:w-min w-full"}
										disabled={
											!agbAccepted ||
											!spamFilterPassed
										}
										type="submit"
										height={"h-[48px]"}
										className="rounded-[10px]"
										padding={"px-6 py-[14px] uppercase font-bold text-[14px]"}
										bgColor="bg-gradient-to-b from-[#b6aa9b] to-[#857a6d]"
										hoverBgColor="hover:bg-leo-dark-brown hover:from-transparent hover:to-transparent"
									/>
								</div>
							</div>
						</div>
					</form>
				</div>
            </div>
        </div>
    );
}